import api from './api';

export interface CentroTrabalho {
  id: string;
  codigo: string;
  descricao: string;
  tipo: string;
  capacidade_hora?: number | null;
  custo_hora?: number | null;
  ativo: boolean;
}

export type CentroTrabalhoInput = Partial<Omit<CentroTrabalho, 'id'>>;

const ENDPOINT = '/industrializacao/centro-trabalho';

const centroTrabalhoService = {
  async listar(): Promise<CentroTrabalho[]> {
    const response = await api.get<CentroTrabalho[]>(ENDPOINT);
    return response.data;
  },
  async buscarPorId(id: string): Promise<CentroTrabalho> {
    const response = await api.get<CentroTrabalho>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async criar(data: CentroTrabalhoInput): Promise<CentroTrabalho> {
    const response = await api.post<CentroTrabalho>(ENDPOINT, data);
    return response.data;
  },
  async atualizar(id: string, data: CentroTrabalhoInput): Promise<CentroTrabalho> {
    const response = await api.put<CentroTrabalho>(`${ENDPOINT}/${id}`, data);
    return response.data;
  },
  async excluir(id: string): Promise<void> {
    await api.delete(`${ENDPOINT}/${id}`);
  },
};

export default centroTrabalhoService;
